import Marquee from "react-fast-marquee";
import { Asterisk } from "lucide-react";

const words = [
  "Teaching & Learning Enhancement",
  "Inclusive Education",
  "Student Wellbeing",
  "Future-Ready Schools",
  "Evidence-Led",
  "Person-Centred Schools",
];

export const Ribbon = () => (
  <section className="bg-terra text-white py-5 border-y border-ink/10" data-testid="ribbon">
    <Marquee speed={38} gradient={false} autoFill>
      {words.map((w) => (
        <span key={w} className="flex items-center font-serif text-2xl md:text-4xl italic mx-8">
          {w}
          <Asterisk className="w-6 h-6 md:w-8 md:h-8 ml-8 not-italic" strokeWidth={1.5} />
        </span>
      ))}
    </Marquee>
  </section>
);
